import React, { Component } from 'react';


class AsrDeploy extends Component {
    constructor() {
        super();
    }

    routeToReferenceDoc = () => {
        window.open("https://github.com/DheeYantra/dhee-online-transcription-api-js", "_blank")
    }

    render() {
        return (
            <div>
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <div className="wrapper" style={{ height: "430px" }}>
                    <div className="row">
                        <div className="col-12">
                            {/* Custom Tabs */}
                            <h6 className="nav-item" style={{
                                color: '#282a65',
                                marginTop: '10px', marginLeft: '20px'
                            }}>Deploy</h6>

                            <div className="card-body p-0 mb-25" style={{ marginLeft: "20px" }}>
                                <div className="tab-content col-12 p-0">
                                    <div className="tab-pane active show" id="tab_1">
                                        <div className="card card-primary mt-3">
                                            <div className="card-body raise-form">
                                                <div className="col-sm-12">
                                                    <div className="col-sm-7">
                                                        <div style={{ width: 'auto' }}>
                                                            <div style={{
                                                                marginTop: '10px', marginLeft: '20px', color: '#282a65',
                                                            }}>For Asr Api usage you will be charged 1.75 rupees per minute
                                                            </div>
                                                            <div style={{
                                                                marginTop: '10px', marginLeft: '20px', color: '#282a65',
                                                            }}>Please deploy from <a href={window.origin + "/platform/projectmgmt/test-and-deploy/DistributionWidget"}>Unified Project Launchpad</a>
                                                            </div>
                                                            <div style={{ marginTop: '20px', marginLeft: '20px' }}>
                                                                <h4>Note:</h4>
                                                                <div style={{ lineHeight: '2', marginTop: '-7px', color: '#282a65' }}>
                                                                    {/* Please give 5 minutes from the deployment time for the voice bots to sync up with new voice models.<br /> */}
                                                                    To integrate the voice agent with your website please refer our JavaScript Api documentation at<br />
                                                                    <a style={{ cursor: 'pointer', color:'#007bff' }} onClick={this.routeToReferenceDoc}>https://github.com/DheeYantra/dhee-online-transcription-api-js</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AsrDeploy


// WEBPACK FOOTER //
// ./src/asrUi/AsrDeploy.js